import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/config';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from 'src/app/shared/shared-module/material.module';

@Component({
    selector: 'app-blank',
    templateUrl: './blank.component.html',
    styleUrls: [],
    imports: [RouterOutlet, MaterialModule, CommonModule]
})
export class BlankComponent {
  private htmlElement!: HTMLHtmlElement;

  options = this.settings.options()

  constructor(private settings: CoreService) {
    this.htmlElement = document.querySelector('html')!;
    this.receiveOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }
}
